module.exports = __webpack_public_path__ + "img/cross-little.6cd668f.svg";